module.exports = __webpack_public_path__ + "8812f5b99f57d8fb587beddeb23ea350.svg";